<template>
    <div>
        <froala
            v-if="froala"
            ref="textarea"
            v-model="selected"
            :tag="'textarea'"
            :config="froalaConfig"
            rows="5"
            size="sm"
            no-resize
        />
        <Editor
            v-else-if="markdown"
            ref="toastuiEditor"
            :options="editorConfig"
            :initial-edit-type="editorMode"
            preview-style="tab"
            @change="onEditorChange"
        />
    </div>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
import axios from 'axios';

export default {

    components: {
        Editor,
    },

    props: {
        tooltip: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            required: true,
        },
        froala: {
            type: Boolean,
            default: false,
        },
        markdown: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            froalaConfig: {
                toolbarButtons: ['bold', 'italic', 'underline'],
                fileUploadURL: '/api/media',
                imageUploadUrl: '/api/media',
            },
            editorMode: 'wysiwyg',
            editorConfig: {
                hideModeSwitch: false,
                usageStatistics: false,
                hooks: {
                    addImageBlobHook: (blob, callback) => {
                        const formData = new FormData();
                        formData.append('file', blob);

                        axios.post('/api/media', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }).then((response) => {
                            callback(response.data.url, '');
                        });
                    },
                    changeMode: (mode) => {
                        localStorage.setItem('editorMode', mode);
                    },
                },
            },
        };
    },

    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(val) {
                this.value = val;
                this.$emit('input', this.value);
            },
        },
    },

    mounted() {
        this.editorMode = localStorage.getItem('editorMode') || 'wysiwyg';

        if (this.markdown) {
            this.$refs.toastuiEditor.invoke('setMarkdown', this.selected);
        } else if (!this.froala) {
            this.$refs.textarea.select();
        }
    },

    methods: {
        onEditorChange() {
            this.selected = this.$refs.toastuiEditor.invoke('getMarkdown');
        },
    },

};
</script>
